import { Stop } from "@api/graphql/generated/generated-types";

interface ShipmentWithStopLocations {
  stops: Array<{
    id: string;
    streetAddress?: string | null;
    locationId?: string | null;
  }>;
}

export const findLocationId = (
  stopUserChanged: Stop,
  shipmentSelectedForAction: ShipmentWithStopLocations
) => {
  if (stopUserChanged.locationId) {
    return stopUserChanged.locationId;
  }
  const initialStop = shipmentSelectedForAction.stops.find(
    (stop) => stop.id === stopUserChanged.id
  );
  if (!initialStop) {
    return undefined;
  }
  if (initialStop.streetAddress === stopUserChanged.streetAddress) {
    return initialStop.locationId;
  } else {
    return undefined;
  }
};
export const findGooglePlaceId = (
  stopUserChanged: Stop,
  shipmentSelectedForAction: ShipmentWithStopLocations
) => {
  if (stopUserChanged.googlePlaceId) {
    return stopUserChanged.googlePlaceId;
  }
  const initialStop = shipmentSelectedForAction.stops.find(
    (stop) => stop.id === stopUserChanged.id
  );
  if (initialStop?.streetAddress === stopUserChanged.streetAddress) {
    return undefined;
  } else {
    return stopUserChanged.googlePlaceId;
  }
};
